import { el } from 'redom';

class RightPanelFullscreenToggle {

  constructor() {

    this.moduleMain = null;
    this.expanded = false;
    this.toggleContainer = null;
    this.toggleLine = el('.right-panel-toggle-line', {
      onclick: this.toggle.bind(this)
    });

  }

  activate(configuration) {

    this.moduleMain = configuration.moduleMain;
    this.middlePanel = this.moduleMain.children[0];
    this.rightPanel = this.moduleMain.children[1];
    this.toggleContainerSelector = configuration.toggleContainerSelector;
    this.onExpanded = configuration.onExpanded || function noop() {};
    this.onRestored = configuration.onRestored || function noop() {};

    if (this.expanded === true) {
      this.moduleMain.classList.add('right-panel-expanded');
      this.onExpanded();
    } else {
      this.moduleMain.classList.remove('right-panel-expanded');
      this.onRestored();
    }

    // this.middlePanel.appendChild(this.toggleLine);

  }

  getStartupMain() {

    return document.getElementById('startup-main');

  }

  restore() {

    const startupMain = this.getStartupMain();

    this.expanded = false;

    /* beautify ignore:start */
    startupMain.querySelector('.top-level-module-main')?.classList.remove('right-panel-expanded');
    /* beautify ignore:end */
    startupMain.classList.remove('application-expanded');

    if (typeof this.onRestored === 'function') {
      this.onRestored();
    }

  }

  expand() {

    const startupMain = this.getStartupMain();

    this.expanded = true;

    /* beautify ignore:start */
    startupMain.querySelector('.top-level-module-main')?.classList.add('right-panel-expanded');
    /* beautify ignore:end */
    startupMain.classList.add('application-expanded');

    if (typeof this.onExpanded === 'function') {
      this.onExpanded();
    }

  }

  toggle() {

    if (this.expanded === true) {
      this.restore();
    } else {
      this.expand();
    }

  }

  update(configuration) {
    this.onExpanded = configuration.onExpanded || function noop() {};
    this.onRestored = configuration.onRestored || function noop() {};
  }

  refresh() {

    if (this.middlePanel === this.moduleMain.children[0]) {
      return;
    }

    this.middlePanel = this.moduleMain.children[0];
    this.rightPanel = this.moduleMain.children[1];

    // this.middlePanel.appendChild(this.toggleLine);

  }

  isExpanded() {

    return this.expanded;

  }

}

export default RightPanelFullscreenToggle;